import * as React from 'react';

export function SvgSmileAlt(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.987 13.018A1 1 0 018.8 12.6h6.4a1 1 0 01.947 1.321C15.54 15.71 13.927 17 12 17c-1.926 0-3.54-1.29-4.147-3.079a1 1 0 01.134-.903zm2.74 1.582c.376.258.816.4 1.273.4.457 0 .896-.142 1.273-.4h-2.546zM8.6 9.6a1 1 0 011-1h.01a1 1 0 010 2H9.6a1 1 0 01-1-1zM13.4 9.6a1 1 0 011-1h.01a1 1 0 110 2h-.01a1 1 0 01-1-1z"
        fill="currentColor"
      />
    </svg>
  );
}
